import React, { memo } from 'react';
import { MomentData, LinkedMoment } from '../types';
import styles from './MilestoneRow.module.scss';
import { formatPhaseDateShort } from './utils';

interface PhaseDateCellProps {
  moment: MomentData | LinkedMoment;
  column: any;
}

const PhaseDateCell: React.FC<PhaseDateCellProps> = memo(
  ({ moment, column }) => {
    const dateValue = (moment as any).phaseDates?.[column.dateField];

    if (!dateValue) {
      return (
        <td
          className={styles.milestoneCell}
          data-phase-date="true"
          data-phase-date-empty="true"
          style={{ width: '100px' }}
        />
      );
    }

    const formattedDate = formatPhaseDateShort(dateValue);

    return (
      <td
        className={styles.milestoneCell}
        data-phase-date="true"
        style={{ width: '100px' }}
      >
        <div className={styles.milestoneContent}>
          <div className={styles.milestoneValueContent}>
            <div className={styles.dateText}>{formattedDate}</div>
          </div>
        </div>
      </td>
    );
  }
);

PhaseDateCell.displayName = 'PhaseDateCell';

export default PhaseDateCell;
